__turbopack_context__.v({
  "__cover-image": "client-landing-page-module-scss-module__OTKtBq____cover-image",
  "__title": "client-landing-page-module-scss-module__OTKtBq____title",
  "client-landing-page": "client-landing-page-module-scss-module__OTKtBq__client-landing-page",
});
